import { useEffect, useContext } from "react";
import { InputSelect } from "../components/formComponents/inputSelect";
import { mensajeSimple } from "../components/ui/sweetAlerts";
import { ModalContractuales } from "./modalForm/modalForm";
import { DataContext } from "../contextData/contextData";
import { UseModalForm } from "./modalForm/useModalForm";
import { useIndex } from "./useIndex";
import { useLayoutEffect } from "react";

export const Index = (props) => {
  const { modulo } = props;
  const { uno, setNombreMenuu } = useContext(DataContext);
  const { traerData, filtrarUno, arrData, objTipoContrato, formatFecha } = useIndex();
  const { visible, hideModal, dataModal, procesoSelected } = UseModalForm();

  useEffect(() => {
    traerData();
    setNombreMenuu("Iniciar solicitud");
  }, []);
  useLayoutEffect(() => {
    filtrarUno();
  }, []);

  return (
    <>
      <ModalContractuales data={dataModal} show={visible} hideModal={hideModal} cambioSelected={procesoSelected} />
      <div className="d-flex align-items-center flex-column">
        <div className="col col-12 col-lg-8 col-xl-6 px-4">
          <InputSelect
            label="Colaborador"
            placeholder="--Seleccione colaborador--"
            llave_texto="REEO_NOMBRE_COMPLETO"
            llave_valor="REEO_CODIGO_POSICION"
            arr={arrData}
            ejecute={filtrarUno}
            id="select_Colaborador"
          />
        </div>
        {uno !== undefined && (
          <>
            <div className="col col-12 col-lg-8 col-xl-8 px-4 mt-4">
              <div className="table-responsive">
                <table className="table table-bordered table-sm">
                  <thead id="head-tabla">
                    <tr>
                      <th>Rut</th>
                      <th>Nro. personal</th>
                      <th>Pos. actual</th>
                      <th>Cargo actual</th>
                      <th>PHTD</th>
                      <th>Fecha alta</th>
                      <th>Contrato</th>
                    </tr>
                  </thead>
                  <tbody id="body-tabla">
                    <tr>
                      <td>{uno.REEO_RUT}</td>
                      <td>{uno.REEO_CODIGO_SAP}</td>
                      <td>{uno.REEO_CODIGO_POSICION}</td>
                      <td>{uno.estructura.MOES_DESCRIPCION_POSICION}</td>
                      <td>{uno.REEO_PLAN_HORARIO}</td>
                      <td>{formatFecha(uno.REEO_FECHA_INICIO_CONTRATO)}</td>
                      <td>{objTipoContrato[uno.REEO_TIPO_CONTRATO]}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="col col-12 col-lg-8 col-xl-6 px-2">
              <table className="table table-borderless table-hover tablaOpciones mt-3">
                <tbody>
                  {modulo !== "3" ? (
                    <>
                      <tr
                        onClick={() => {
                          hideModal(1);
                        }}
                      >
                        <td>Cambio de cargo (SAP & Temporis)</td>
                      </tr>
                      <tr
                        onClick={() => {
                          hideModal(2);
                        }}
                      >
                        <td>Cambio de unidad (Temporis)</td>
                      </tr>
                      <tr
                        onClick={() => {
                          hideModal(3);
                        }}
                      >
                        <td>Cambio de instalación</td>
                      </tr>
                      <tr
                        className={`${["01"].includes(uno["REEO_TIPO_CONTRATO"]) ? "text-through" : ""}`}
                        onClick={() => {
                          if (["01"].includes(uno["REEO_TIPO_CONTRATO"])) {
                            mensajeSimple("info", "Este colaborador(a) posee Contrato Indefinido", 2300);
                            return;
                          }
                          hideModal(4);
                        }}
                      >
                        <td>Estatus contrato de trabajo (Renovación Plazo Fijo e Indefinido)</td>
                      </tr>
                    </>
                  ) : (
                    <tr
                      onClick={() => {
                        hideModal(5);
                      }}
                    >
                      <td>Solicitud de desvinculación del colaborador</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </>
        )}
      </div>
    </>
  );
};
